import { PurchaseOrderReportStockIssues } from './purchase-order-report-stock-issues';
import { YarnSpecReport } from 'tms-lib';
import { PurchaseOrderReportBillOfMaterials } from './purchase-order-report-bill-of-materials';
import { PurchaseOrderReportLineProcessing } from './purchase-order-report-line-processing';

export interface PurchaseOrderLineReport {
  productKey: string;
  productDescription: string;
  productOldCode: string;
  makeUp: string;
  contractNumber: string;
  supplierLineRef: string;
  supplierProductRef: string;
  quantity: number;
  quantityString: string;
  quantityHtmlString: string;
  quantityPickString: string;
  unit: string;
  price: number;
  priceString: string;
  value: number;
  valueString: string;
  deliveryDate: Date;
  deliveryDateString: string;
  currencySymbol: string;
  deliveryNotes: string;
  supplierNotes: string;
  productId: string;
  attachSpecPrintToPurchaseOrder: boolean;
  labelDescription: string;
  sizeDescription: string;
  sampleInformation: string;
  comments: string;
  yarnSpec: YarnSpecReport;

  purchaseOrderLineStockIssues: PurchaseOrderReportStockIssues[];
  purchaseOrderBillOfMaterialItems: PurchaseOrderReportBillOfMaterials[];
  purchaseOrderReportLineProcessings: PurchaseOrderReportLineProcessing[];
}
